import { Delegate1, Delegate2, generateUUID } from "flavr-common";
import { busService } from "../../bus";
import { CreateSharedArrayMessage, DestroySharedArrayMessage, SharedArrayBufferMessage } from "../../../messages/sharedArray/SharedArrayMessages";
import { SharedBuffer } from "./SharedBuffer";
export var BufferState;
(function (BufferState) {
    BufferState[BufferState["Uninitialized"] = 0] = "Uninitialized";
    BufferState[BufferState["Ready"] = 1] = "Ready";
    BufferState[BufferState["Consumed"] = 2] = "Consumed";
})(BufferState || (BufferState = {}));
export class SharedArrayService {
    constructor() {
        this.connection = busService.connection("SharedArrayService");
        this.sharedArrays = new Map();
        this.sharedArraysTypeMap = new Map();
        this.onCreatedForTypeSubscriptions = new Map();
        this.onDestroyedForTypeSubscriptions = new Map();
        this.sharedBuffers = new Map();
        this.handleSharedArrayBufferMessage = (msg) => {
            const data = this.sharedArrays.get(msg.id);
            if (!data)
                return;
            data.sharedArray.onBufferCreated(msg.buffer);
        };
        this.handleCreateSharedArrayMessage = (msg, meta) => {
            const sharedBuffer = new SharedBuffer(msg.id, msg.sharedType, meta.timeStamp, meta.source.workerId, msg.uId);
            this.sharedBuffers.set(msg.id, sharedBuffer);
            sharedBuffer.onDestroyedDelegate.add(this.onSharedBufferDestroyed);
            const subscription = this.onCreatedForTypeSubscriptions.get(msg.sharedType);
            if (!subscription)
                return;
            subscription.invoke(sharedBuffer);
        };
        this.onSharedBufferDestroyed = (sharedBuffer) => {
            const message = new DestroySharedArrayMessage(sharedBuffer.id, sharedBuffer.sharedType);
            this.handleDestroySharedArrayMessage(message);
            this.connection.send(message);
        };
        this.handleDestroySharedArrayMessage = (msg) => {
            const sharedBuffer = this.sharedBuffers.get(msg.id);
            if (sharedBuffer) {
                sharedBuffer.onDestroy();
                this.sharedBuffers.delete(msg.id);
            }
            const sharedArray = this.sharedArrays.get(msg.id);
            if (sharedArray) {
                this.sharedArrays.delete(msg.id);
            }
            const subscription = this.onDestroyedForTypeSubscriptions.get(msg.sharedType);
            if (!subscription)
                return;
            subscription.invoke(msg.id, msg.type);
        };
        this.connection.subscribeByType(SharedArrayBufferMessage, this.handleSharedArrayBufferMessage);
        this.connection.subscribeByType(CreateSharedArrayMessage, this.handleCreateSharedArrayMessage);
        this.connection.subscribeByType(DestroySharedArrayMessage, this.handleDestroySharedArrayMessage);
    }
    isSharedArrayBufferSupported() {
        return !!self.SharedArrayBuffer;
    }
    subscribeCreated(type, callback) {
        if (this.onCreatedForTypeSubscriptions.has(type)) {
            throw new Error(`SharedArrayService: Already subscribed for type ${type}`);
        }
        const delegate = new Delegate1();
        delegate.set(callback);
        this.onCreatedForTypeSubscriptions.set(type, delegate);
    }
    unsubscribeCreated(type) {
        this.onCreatedForTypeSubscriptions.delete(type);
    }
    subscribeDestroyed(type, callback) {
        if (this.onDestroyedForTypeSubscriptions.has(type)) {
            throw new Error(`SharedArrayService: Already subscribed for type ${type}`);
        }
        const delegate = new Delegate2();
        delegate.set(callback);
        this.onDestroyedForTypeSubscriptions.set(type, delegate);
    }
    unsubscribeDestroyed(type) {
        this.onDestroyedForTypeSubscriptions.delete(type);
    }
    add(sharedArray) {
        if (this.sharedArrays.has(sharedArray.id))
            return;
        this.sharedArrays.set(sharedArray.id, {
            sharedArray
        });
        let sharedArrays = this.sharedArraysTypeMap.get(sharedArray.type);
        if (!sharedArrays) {
            sharedArrays = new Set();
            this.sharedArraysTypeMap.set(sharedArray.type, sharedArrays);
        }
        sharedArrays.add(sharedArray);
        this.connection.send(new CreateSharedArrayMessage(sharedArray.id, sharedArray.type, sharedArray.uId), undefined, undefined, undefined, sharedArray.targetWorkerId);
    }
    destroy(sharedArray) {
        this.sharedArrays.delete(sharedArray.id);
        const sharedArrays = this.sharedArraysTypeMap.get(sharedArray.type);
        if (sharedArrays) {
            sharedArrays.delete(sharedArray);
        }
        this.connection.send(new DestroySharedArrayMessage(sharedArray.id, sharedArray.type), undefined, undefined, undefined, sharedArray.targetWorkerId);
    }
    postBuffer(sharedBuffer) {
        const buffer = sharedBuffer.getBuffer();
        if (!buffer)
            return;
        busService.postSharedArrayBuffer("SharedArrayService", sharedBuffer.fromWorkerId, sharedBuffer.id, buffer);
        return true;
    }
    generateId() {
        let uuid = generateUUID();
        while (this.sharedArrays.has(uuid)) {
            uuid = generateUUID();
        }
        return uuid;
    }
}
export const sharedArrayService = new SharedArrayService();
